{
  "401": {
    "title": "Insufficient permissions",
    "description": "Sorry, you ({{email}}) do not have sufficient permissions to view this page. Please contact your sales representative for more information.",
    "button": "Go back to login page",
    "button2": "Logout"
  },
  "404": {
    "title": "Sorry, page not found!",
    "description": "Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.",
    "button": "Go back to the homepage"
  },
  "500": {
    "title": "Sorry, something went wrong!",
    "description": "Sorry, something went wrong. Please try again later.",
    "button": "Go back to the homepage"
  },
  "Search": "Search",
  "Searchingfor": "Searching for",
  "Logout": "Logout",
  "login": "Login",
  "SatellietOriginals": "Satelliet Originals",
  "Prijslijst": "Pricelist",
  "IfThisErrorPersists": "If this error persists, please contact us at solutions@satelliet.net.",
  "language": {
    "English": "English",
    "Dutch": "Nederlands"
  },
  "navbar": {
    "info": "Supplemental information",
    "brands": "Brands",
    "colorChart": "Color chart",
    "fermob": "Fermob",
    "Home": "Home",
    "SearchPrijslijst": "Search the Pricelist",
    "Delivery": "Delivery",
    "coatings": "Overcoating",
    "fabrics": "Fabrics and leather",
    "prices": "Prices",
    "fabricChart": "Fabric table",
    "USPs": "USPs",
    "fabricsOverview": "Fabrics overview",
    "outdoorStock": "Stock collection outdoor fabrics"
  },
  "GA": {
    "body": "This website uses cookies to ensure you get the best experience on our website. By clicking on 'Accept' you agree to the use of these cookies.",
    "accept": "Accept",
    "decline": "Decline"
  },
  "footer": {
    "pricingExclVAT": "All prices are exclusive of VAT",
    "statements": "Statements",
    "salesConditions": "Conditions of sale",
    "cookieStatement": "Cookie policy",
    "privacyStatement": "Privacy statement",
    "showrooms": "Showrooms",
    "contact": "Contact",
    "sustainability": "Sustainability",
    "aboutSatelliet": "About Satelliet",
    "aboutSatellietOriginals": "About Satelliet Originals",
    "salesConditionsUrl": "https://www.satelliet.net/en/conditions-of-sale/",
    "cookieStatementurl": "https://www.satelliet.net/en/cookie-policy/",
    "privacyStatementUrl": "https://www.satelliet.net/en/privacy-statement/",
    "aboutSatellietUrl": "https://www.satelliet.net/en/about-satelliet/about-our-organisation/",
    "sustainabilityUrl": "https://www.satelliet.net/en/csr-sustainability/",
    "showroomsUrl": "https://www.satelliet.net/en/showrooms/",
    "contactUrl": "https://www.satelliet.net/en/service-contact/"
  },
  "Version": "Version",
  "ascName": "Name ↑",
  "descName": "Name ↓",
  "descSalesCount": "Popularity ↓",
  "descPageViews": "Page views ↓",
  "ascPrice": "Price ↑",
  "descPrice": "Price ↓",
  "currencies": {
    "EUR": "Euro (€)",
    "USD": "US Dollar ($)",
    "GBP": "British Pound (£)",
    "CHF": "Swiss Franc (CHF)",
    "NOK": "Norwegian Krone (kr)"
  }
}
